export const data = [
  {
    id: 1,
    name: 'MG Engenharia',
    email: 'mgengenharia@gmail.com',
    plan: 'Premium',
    signature_date: '2021-09-01',
    last_payment: '2022-04-01',
    works_started: '27',
    used_space: '16',
    total_space: '20',
  },
  {
    id: 2,
    name: 'FS Engenharia',
    email: 'fsengenharia@gmail.com',
    plan: 'Padrão',
    signature_date: '2021-08-24',
    last_payment: '2022-03-24',
    works_started: '5',
    used_space: '3',
    total_space: '10',
  },
  {
    id: 3,
    name: 'AS Engenharia',
    email: 'asengenharia@gmail.com',
    plan: 'Premium',
    signature_date: '2021-07-17',
    last_payment: '2022-02-17',
    works_started: '2',
    used_space: '1',
    total_space: '10',
  },
];
